import React, { Component } from "react";
import {
  Responsive,
  Visibility,
  Segment,
  Menu,
  Container,
  Image,
  Grid
} from "semantic-ui-react";
import ContentContainer from "./ContentContainer";
import iconWhatsApp from "./../static/icons8-whatsapp.svg";
import iconFacebook from "./../static/icons8-facebook.svg";
import iconInstagram from "./../static/instagram.svg";
import {
  navigateToSection,
  onFacebookClick,
  onWhatsClick,
  onInstagramClick
} from "./../js";
import logoOriginal from "./../static/logo_original.png";
import colors from "./../js/colors";

const getWidth = () => {
  const isSSR = typeof window === "undefined";

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

const styles = {
  contactContainer: {
    backgroundColor: colors.dark
  },
  contactColumn: {
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: 25,
    color: colors.light
  },
  menuItem: {
    marginBottom: 8,
    fontWeight: "bold"
  },
  social: {
    cursor: "pointer",
    marginLeft: 20
  }
};

class DesktopContainer extends Component {
  state = {
    logo: logoOriginal,
    fixed: false,
    bgHome: colors.light
  };

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Container fluid style={styles.contactContainer}>
            <Grid container>
              <Grid.Row>
                <Grid.Column
                  floated="right"
                  textAlign="right"
                  style={styles.contactColumn}
                >
                  <span style={{ marginRight: 20 }}>
                    {"contato@varaisalpha.com.br"}
                  </span>
                  <span style={{ marginRight: 20 }}>{"Tel: 4707-1958"}</span>
                  <span>{"Cel/What's: (11) 9 9919-8944"}</span>
                  <Image
                    avatar
                    src={iconWhatsApp}
                    style={{
                      ...styles.social,
                      width: "1.7em",
                      height: "1.7em"
                    }}
                    onClick={() => onWhatsClick()}
                  />
                  <Image
                    avatar
                    src={iconFacebook}
                    style={styles.social}
                    onClick={() => onFacebookClick()}
                  />
                  <Image
                    avatar
                    src={iconInstagram}
                    style={{
                      ...styles.social,
                      width: "1.6em",
                      height: "1.6em",
                      borderRadius: 0
                    }}
                    onClick={() => onInstagramClick()}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Visibility>
        <Segment
          textAlign="center"
          style={{
            backgroundColor: this.state.bgHome,
            maxHeight: "1438px",
            padding: "0em 0em",
            margin: "0"
          }}
          vertical
        >
          <Menu
            fixed={fixed ? "top" : null}
            pointing
            secondary
            size="massive"
            style={{ backgroundColor: "#f0f2ec", margin: 0 }}
          >
            <Container>
              <Menu.Item as={Image} style={{ paddingBottom: "0" }}>
                <Image
                  src={this.state.logo}
                  alt="logo-varais-alpha"
                  style={{ width: 80, height: 50, marginBottom: 10 }}
                />
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={() => navigateToSection("section-home")}
                style={styles.menuItem}
              >
                <span>Home</span>
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={() => navigateToSection("section-empresa")}
                style={styles.menuItem}
              >
                Empresa
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={() => navigateToSection("section-produtos")}
                style={styles.menuItem}
              >
                Produtos
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={() => navigateToSection("section-imagens")}
                style={styles.menuItem}
              >
                Imagens
              </Menu.Item>
              <Menu.Item
                as="a"
                onClick={() => navigateToSection("section-contato")}
                style={styles.menuItem}
              >
                Contato
              </Menu.Item>
            </Container>
          </Menu>
          <ContentContainer mobile={false} bgHome={this.state.bgHome} />
        </Segment>

        {children}
      </Responsive>
    );
  }
}

export default DesktopContainer;
